module.exports = __webpack_public_path__ + "img/logo.2f780558.png";